import React, { useState, useEffect } from 'react';
import TotalValue from "../TotalValue/TotalValue";
import './BarChart.styles.scss';
import {Link} from "react-router-dom";

const BarChartOccasion = ({ data }) => {

    const [maxValue, setMaxValue] = useState(0.0001);

    useEffect(() => {
        let max = 0;
        data.forEach((item) => {
            const { value, total } = item;
            max = Math.max(max, value, total);
        });
        setMaxValue(max);
    }, [data]);

    return (
        <div className="barChart">
            {data.map((bar, inx) => {

                const title = {
                    component: 'div',
                    props: {
                        className: 'barChart__name',
                        style: {
                            width: `${((window.innerWidth/data.length)).toFixed(0)}px`
                        }
                    }
                };

                if (bar.link) {
                    title.props.to = bar.link;
                    title.component = Link;
                }

                return (
                    <div
                        key={inx}
                        className="barChart__item"
                    >
                        <div
                            className="barChart__bar"
                            style={{ height: `${((bar.value/maxValue) * 100).toFixed(0)}%` }}
                        >
                            <div className="barChart__value">{bar.value}%</div>
                        </div>
                        {/*<div
                            className="barChart__total"
                            style={{ height: `${((bar.total/maxValue) * 100).toFixed(0)}%` }}
                        >
                            <TotalValue className="barChart__total-value">
                                {bar.total}%
                            </TotalValue>
                        </div>*/}

                        <title.component {...title.props}>
                            {bar.name}
                        </title.component>

                    </div>
                )
            })}
        </div>
    )
};

export default BarChartOccasion;